var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEyeView = function SvgEyeView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.602 6.372A6.258 6.258 0 0 0 6 2.375 6.259 6.259 0 0 0 .397 6.372a.375.375 0 0 0 0 .256A6.259 6.259 0 0 0 6 10.625a6.26 6.26 0 0 0 5.602-3.997.375.375 0 0 0 0-.256ZM6 9.875c-1.988 0-4.088-1.474-4.849-3.375C1.912 4.599 4.012 3.125 6 3.125c1.987 0 4.087 1.474 4.849 3.375-.762 1.901-2.862 3.375-4.85 3.375Z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.25a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM6 8a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z",
    fill: "#707070"
  })));
};
export default SvgEyeView;